import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var NotificationBellFilledSvg = function NotificationBellFilledSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.79 9.375c0-1.89.76-3.702 2.112-5.039A7.25 7.25 0 0 1 12 2.25c1.912 0 3.746.75 5.098 2.087a7.09 7.09 0 0 1 2.111 5.04v4.434l2.292 4.531h-19l2.29-4.53zm5.35 12.874h3.72v-1.84h-3.72z",
    clipRule: "evenodd"
  }));
};
export var NotificationBellFilled = function NotificationBellFilled(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: NotificationBellFilledSvg
  }));
};